(() => {
  if (customElements.get('drapeur-low-stock')) return;
  class DrapeurLowStock extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-section-type="product"]');
      const data = this.querySelector('[data-low-stock-variants]');
      this.label = this.querySelector('[data-low-stock-label]');
      if (!this.root || !data || !this.label) return;
      try { this.variants = JSON.parse(data.textContent).variants; }
      catch { this.hidden = true; return; }
      this.onVariantChange = event => this.update(event.detail?.variant?.id);
      this.root.addEventListener('variantChange', this.onVariantChange);
      this.update(this.dataset.initialVariant);
    }
    disconnectedCallback() {
      this.root?.removeEventListener('variantChange', this.onVariantChange);
    }
    update(id) {
      const quantity = this.variants[String(id)];
      const text = quantity === 1 ? this.dataset.one : quantity === 2 ? this.dataset.two : '';
      this.label.textContent = text;
      this.hidden = !text;
    }
  }
  customElements.define('drapeur-low-stock', DrapeurLowStock);
})();
